import { IEvent } from "@lib/store/src/calendar";
import { EBACnetDataTypes } from "./modal.types";
import { v4 as uuidv4 } from "uuid";
import i18next from "i18next";

/**
 * Валидация значения по типу данных BACnet (EBACnetDataTypes)
 *
 * @param {EBACnetDataTypes} dataType - Тип данных EBACnetDataTypes
 * @param {any} value - Значение для проверки
 * @returns {string} - Прошло ли значение проверку
 */
export const validateBACnetValue = (value: any, dataType: number): string => {
  switch (dataType) {
    case EBACnetDataTypes.NULL:
    case EBACnetDataTypes.BOOLEAN:
      return "";

    // case EBACnetDataTypes.TIME:
    // case EBACnetDataTypes.DATE: {
    //   if (value === null || value === "") return "Не выбрано значение";
    //   return "";
    // }

    case EBACnetDataTypes.UNSIGNED_INTEGER: {
      const numberValue = Number(value);
      if (!isNaN(numberValue)) {
        if (Number.isInteger(numberValue)) {
          if (numberValue >= 0) return ""; // Неотрицательное целое число
        }
      }
      return i18next.t($ => $.scheduleBacnet.errorValueMustBeNonNegativeInteger);
    }

    case EBACnetDataTypes.SIGNED_INTEGER: {
      const numberValue = Number(value);
      if (!isNaN(numberValue)) {
        if (Number.isInteger(numberValue)) return ""; // Целое число
      }
      return i18next.t($ => $.scheduleBacnet.errorValueMustBeInteger);
    }

    case EBACnetDataTypes.REAL:
    case EBACnetDataTypes.DOUBLE: {
      const numberValue = Number(value);
      if (!isNaN(numberValue)) return ""; // Любое число
      return i18next.t($ => $.scheduleBacnet.errorValueMustBeNumber);
    }

    // case EBACnetDataTypes.OCTET_STRING:
    //   if (/^[0-9A-Fa-f]+$/.test(value)) return ""; // Шестнадцатеричная строка
    //   return "Значение должно быть строкой из шестнадцатеричных символов";

    // case EBACnetDataTypes.CHARACTER_STRING:
    //   if (typeof value === "string") return ""; // Любая строка
    //   return "Значение должно быть строкой";

    // case EBACnetDataTypes.BIT_STRING:
    //   if (/^[01]+$/.test(value)) return ""; // Бинарная строка
    //   return "Значение должно быть строкой из символов 0 и 1";

    // case EBACnetDataTypes.OBJECT_IDENTIFIER:
    //   if (/^\d+(\.\d+)+$/.test(value)) return false; // Строка из чисел, разделенных точками
    //   return "Значение должно быть строкой из чисел, разделенных точками, для типа OBJECT_IDENTIFIER";

    case EBACnetDataTypes.ENUMERATION:
      return "";

    default:
      return `Неизвестный тип данных: ${dataType}`;
  }
};

/**
 * Заполнение компонента "fw-select" типами данных BacNet
 *  @param {Element} selectType DOM-element fw-select для заполнения типами данных
 *  @returns {Element} - Заполненный "fw-select"
 */
export const initTypeSelect = (selectType: Element, event?: IEvent) => {
  if (!selectType) return null;

  const enums = Object.entries(EBACnetDataTypes).filter(
    ([_, v]) => typeof v === "string"
  );

  const selectOption = document.createElement("option") as HTMLOptionElement;
  selectOption.hidden = true;
  selectOption.selected = true;

  if (event?.dataType !== null) {
    selectOption.textContent = EBACnetDataTypes[event?.dataType];
  }
  selectType.appendChild(selectOption);

  enums.forEach(([key, value]) => {
    const selectOption = document.createElement("option") as HTMLOptionElement;
    selectOption.textContent = String(value);
    selectOption.value = String(key);
    selectType.appendChild(selectOption);
  });

  return selectType;
};

/**
 *  Кастомный time-picker
 *  @returns {string} defaultValue - Значение по умолчанию
 */
export function createTimePickerSelect(defaultValue = "") {
  return `<input type="time" id="time" step="2" value="${defaultValue}" />`
}

/**
 * Получение выбранных дней недели
 */
export const getSelectedWeekDays = (weekDays): number[] => {
  return Array.from(weekDays)
    .map((el, index) => (el.checked ? index : null))
    .filter((el) => el !== null) as number[];
};

/**
 * Создание нового события
 */
export const createNewEvent = (): IEvent => ({
  id: uuidv4(),
  time: {
    hours: "",
    minutes: "",
    seconds: "",
    hundredth: "00",
  },
  dataType: null,
  length: 0,
  value: null,
});

/**
 * Форматирует значение в зависимости от типа и длины
 * @param {string | number} value Значение
 * @param {number} length Длина строки
 * @returns {string} Отформатированное значение
 */
export function formatValue(value: string | number, length: number): string {
  if (value === "*" || value === "**" || value === "****") return value;

  return String(value).padStart(length, "0");
}
